import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

// Add Material Icons
const link = document.createElement("link");
link.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
link.rel = "stylesheet";
document.head.appendChild(link);

// Add Inter font
const fontLink = document.createElement("link");
fontLink.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap";
fontLink.rel = "stylesheet";
document.head.appendChild(fontLink);

// Add title
const title = document.createElement("title");
title.textContent = "Blockseer Explorer";
document.head.appendChild(title);

// Initialize Sentry for error tracking and performance monitoring
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Tunnel requests through our backend to bypass ad blockers
  tunnel: "/api/sentry-tunnel",

  // Environment detection (matches existing pattern from config.ts)
  environment: window.location.hostname.includes('localhost') ? 'local' :
    window.location.hostname.includes('dev-explore.blockseer.com') ? 'dev' :
    'prod',

  // Performance Monitoring (50% sample rate)
  tracesSampleRate: 0.5,

  // Session Replay
  replaysSessionSampleRate: 0, // 0% of normal sessions
  replaysOnErrorSampleRate: 0, // 0% of sessions with errors

  // Only enable if DSN is configured
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

createRoot(document.getElementById("root")!).render(<App />);
